<template>
  <div>
    <v-toolbar flat color="white">
      <v-select
        v-model="statusFrom"
        prepend-icon="done"
        append-icon="search"
        :label="$t('status_selector.status_from')"
        single-line
        hide-details
        clearable
        :items="selectionFrom"
        @input="emitChanges('from')"
      ></v-select>
      <v-select
        v-model="statusTo"
        prepend-icon="done"
        append-icon="search"
        :label="$t('status_selector.status_to')"
        single-line
        hide-details
        clearable
        :items="selectionTo"
        @input="emitChanges('to')"
      ></v-select>
    </v-toolbar>
  </div>
</template>

<script>
import StatusName from "@/models/StatusName.js";
export default {
  props: ["table", "language", "from", "to"],
  data() {
    return {
      statusFrom: this.from != null ? this.from : null,
      statusTo: this.to != null ? this.to : null,
      selectionFrom: [],
      selectionTo: [],
      statusNames: []
    };
  },
  mounted() {
    this.initialize();
  },
  watch: {
    statusFrom() {
      this.statusTo = this.statusFrom;
    },
    statusTo() {
      if (this.statusFrom > this.statusTo) {
        this.statusFrom = this.statusTo;
      }
    }
  },
  methods: {
    async initialize() {
      this.statusNames = await StatusName.loadStatusNames({
        params: {
          table_name: this.table,
          language: this.language
        }
      });
      this.getDisplayedStatuses(this.statusNames);
    },

    getDisplayedStatuses(statusNames) {
      let allowedStatuses = [];
      statusNames.forEach(statusName => {
        allowedStatuses.push({
          value: statusName.status,
          text: statusName.text
        });
      });
      this.selectionFrom = allowedStatuses;
      this.selectionTo = allowedStatuses;
    },

    emitChanges(direction) {
      if(direction == 'from'){
        if(this.statusFrom == 0){
          this.statusTo = this.statusFrom;
        }
      }
      setTimeout(() => {
        this.$emit("statusesChanged", {
          status_from: this.statusFrom,
          status_to: this.statusTo
        });
      }, 10);
    }
  }
};
</script>
